/**
 * A Pokémon's sheet JSON (format v1, written by tools/sprites) as the client reads it, and the
 * frame a loop shows at a given time. No Phaser import.
 */
export interface FacingSheet {
  image: string;
  frameWidth: number;
  frameHeight: number;
  columns: number;
  /** Distinct frames in the sheet, left to right then down. */
  frames: number;
  /** The loop: [frame index, ms] in play order. */
  sequence: [number, number][];
  bytes: number;
}

export interface SheetJson {
  v: 1;
  id: string;
  num: number;
  gen: number;
  front: FacingSheet;
  back: FacingSheet;
}

export const loopMs = (sequence: readonly [number, number][]): number =>
  sequence.reduce((s, [, ms]) => s + ms, 0);

/** The sheet frame showing `ms` into the loop (it repeats forever). */
export function frameAt(sequence: readonly [number, number][], ms: number): number {
  const loop = loopMs(sequence);
  let t = ((ms % loop) + loop) % loop;
  for (const [frame, d] of sequence) {
    if (t < d) return frame;
    t -= d;
  }
  return (sequence.at(-1) as [number, number])[0];
}
